import { DefaultPrivacyLevel } from '@datadog/browser-rum';
import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import Router from 'next/router';

export interface IEnvVariablesResult {
  apiLocation: string;
  autosearchApiLocation: string;
  brand: string;
  dataDog: {
    allowedTracingUrls: string;
    applicationId: string;
    clientToken: string;
    site: string;
    service: string;
    env: string;
    sessionSampleRate: number;
    sessionReplaySampleRate: number;
    trackUserInteractions: boolean;
    trackResources: boolean;
    trackLongTasks: boolean;
    defaultPrivacyLevel: DefaultPrivacyLevel;
  };
}

export const getBaseApi = (baseFolder: string, eApiTags: { [key: string]: string }) => {
  const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
    args,
    api,
    extraOptions
  ) => {
    const baseUrl =
      BaseApi.endpoints.getEnvVariables.select()(api.getState() as any).data?.apiLocation ?? 'https://localhost';

    const rawBaseQuery = fetchBaseQuery({ baseUrl });
    try {
      const result = await rawBaseQuery(args, api, extraOptions);
      if (
        result.error?.status === 429 ||
        (result.error?.status === 'PARSING_ERROR' && result.error.originalStatus === 429)
      ) {
        await Router.push('/429');
      }
      return result;
    } catch (error: any) {
      return {
        error: {
          status: error.status,
          data: error.data,
        },
      };
    }
  };

  const BaseApi = createApi({
    reducerPath: 'baseApi',
    baseQuery: dynamicBaseQuery,
    endpoints: (build) => ({
      getEnvVariables: build.query<IEnvVariablesResult, void>({
        query: () => ({
          url: `//${window.location.host}${baseFolder}/ui/envVariables.json`,
          method: 'GET',
        }),
      }),
    }),
    tagTypes: Object.values(eApiTags),
  });
  return BaseApi;
};
